import React from 'react';
import { Bubble } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend
} from 'chart.js';
import './InvestmentMatrix.css';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

const InvestmentMatrix = () => {
  const opportunityData = [
    { name: 'Zendaya', partnerships: 2, engagement: 3913052, score: 0.95 },
    { name: 'Beyoncé', partnerships: 2, engagement: 1989734, score: 0.85 },
    { name: 'Lily Collins', partnerships: 9, engagement: 1414789, score: 0.82 },
    { name: 'Charli', partnerships: 4, engagement: 1538562, score: 0.78 },
    { name: 'Jackson Wang', partnerships: 2, engagement: 1015827, score: 0.65 },
    { name: 'Chloë Grace Moretz', partnerships: 8, engagement: 950123, score: 0.72 },
    { name: 'Gwyneth Paltrow', partnerships: 12, engagement: 498234, score: 0.68 },
    { name: 'Ashley Benson', partnerships: 2, engagement: 847291, score: 0.55 },
    { name: 'Calvin Klein', partnerships: 1, engagement: 691234, score: 0.45 },
    { name: 'The Walking Dead', partnerships: 1, engagement: 556780, score: 0.40 }
  ];

  const data = {
    datasets: [{
      label: 'Celebrity Opportunity Score',
      data: opportunityData.map(celeb => ({
        x: celeb.partnerships,
        y: celeb.engagement,
        r: celeb.score * 30,
        name: celeb.name,
        score: celeb.score
      })),
      backgroundColor: opportunityData.map(celeb => 
        `rgba(${255 - celeb.score * 255}, ${celeb.score * 255}, 0, 0.6)`
      ),
      borderColor: opportunityData.map(celeb => 
        `rgba(${255 - celeb.score * 255}, ${celeb.score * 255}, 0, 1)`
      ),
      borderWidth: 2
    }]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: 'Celebrity Investment Influence Matrix',
        color: '#C3FF00',
        font: {
          size: 20,
          weight: 'bold'
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const point = context.raw;
            return [
              `Celebrity: ${point.name}`,
              `Brand Partnerships: ${point.x}`,
              `Total Engagement: ${(point.y / 1000000).toFixed(1)}M`,
              `Opportunity Score: ${(point.score * 100).toFixed(0)}%`
            ];
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.8)'
        },
        title: {
          display: true,
          text: 'Number of Brand Partnerships',
          color: 'rgba(255, 255, 255, 0.8)',
          font: {
            size: 14
          }
        }
      },
      y: {
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.8)',
          callback: function(value) {
            return (value / 1000000).toFixed(1) + 'M';
          }
        },
        title: {
          display: true,
          text: 'Total Engagement',
          color: 'rgba(255, 255, 255, 0.8)',
          font: {
            size: 14
          }
        }
      }
    }
  };

  return (
    <div className="investment-matrix glass-card">
      <div className="matrix-container">
        <Bubble data={data} options={options} />
      </div>
      
      <div className="matrix-insights">
        <h4 className="insights-title">High-Value Squad.app Ambassadors</h4>
        <div className="ambassador-grid">
          {opportunityData.slice(0, 6).map((celeb, index) => (
            <div key={celeb.name} className="ambassador-card">
              <span className="ambassador-rank">#{index + 1}</span>
              <span className="ambassador-name">{celeb.name}</span>
              <span className="ambassador-score">{(celeb.score * 100).toFixed(0)}%</span>
            </div>
          ))}
        </div>
        <p className="matrix-note">
          Bubble size represents opportunity score combining engagement reach and brand partnership experience
        </p>
      </div>
    </div>
  );
};

export default InvestmentMatrix;